/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';

require('./bootstrap');
require('./main');
window.Vue = require('vue');

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GOOGLE_MAPS_KEY,
        language: process.env.MIX_GOOGLE_MAPS_LANGUAGE,
        libraries: "geocoding" // necessary for places input
    }
});

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside);

//
// const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : '';
// axios.defaults.baseURL = baseURL;

import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

import MarqueeText from 'vue-marquee-text-component'
Vue.component('marquee-text', MarqueeText);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue.ts -> <example-component></example-component>
 */

import store from './store/store';
// import "./mixins/string.helpers";
// import "./mixins/date.helpers";

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

const modulesFiles = require.context('../../app/Modules/', true, /\.vue$/i);
modulesFiles.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], modulesFiles(key).default));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store,
});
